module.exports = __webpack_public_path__ + "static/media/eligibilityPrimary.7e6a4143.svg";